/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../../Configuration';
import { RestServiceProvider } from '../../RestServiceProvider';
import { AccountService } from './AccountService';

class AccountServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new AccountService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { AccountServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/AccountServiceProvider.js